var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59004 13.5714C1.14485 13.5714 0.768546 13.4189 0.461128 13.1138C0.153709 12.8088 0 12.4354 0 11.9936V1.99848C0 1.55672 0.153709 1.18463 0.461128 0.882215C0.768546 0.579798 1.14485 0.428589 1.59004 0.428589H16.41C16.8551 0.428589 17.2315 0.581121 17.5389 0.886187C17.8463 1.19125 18 1.56467 18 2.00642V12.0016C18 12.4433 17.8463 12.8154 17.5389 13.1178C17.2315 13.4202 16.8551 13.5714 16.41 13.5714H1.59004ZM9 7.74313L1.28569 3.24083V11.9946C1.28569 12.0826 1.31423 12.1549 1.37129 12.2115C1.42836 12.2681 1.50127 12.2964 1.59004 12.2964H16.41C16.4987 12.2964 16.5716 12.2681 16.6287 12.2115C16.6858 12.1549 16.7143 12.0826 16.7143 11.9946V3.24083L9 7.74313ZM9 6.09276L16.5621 1.70362H1.43785L9 6.09276ZM1.28569 3.24083V1.70362V11.9946C1.28569 12.0826 1.31423 12.1549 1.37129 12.2115C1.42836 12.2681 1.50127 12.2964 1.59004 12.2964H1.28569V3.24083Z",
    fill: "#0767FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailActive);
export default __webpack_public_path__ + "static/media/mailActive.5dd80ebd9ff1b73e157277b3e66de16f.svg";
export { ForwardRef as ReactComponent };